import HttpDesc from "./http-desc/Index";
import CallProtocolRules from "./CallProtocolRules/CallProtocolRules";
import VisitLimit from "./visit-limit/VisitLimit";
import PaymentAccessProcess from "./Paymentaccessprocess/PaymentAccessProcess";
import PayProcess from "./PayProcess/PayProcess";
// import Webhook from "./webhook/Index";
import SandboxMode from "@/PageComponents/SandboxMode/index";

export default function Index() {
  return (
    <>
      <HttpDesc />
      <CallProtocolRules />
      <VisitLimit />
      <PaymentAccessProcess />
      <PayProcess />
      <SandboxMode />
      {/* <Webhook /> */}
    </>
  );
}
